export default function getTextColor(color) {
  return parseInt(color.substr(1, 2), 16) * 2 +
    parseInt(color.substr(3, 2), 16) * 5 +
    parseInt(color.substr(5, 2), 16) <=
    8 * 128
    ? '#ffffff'
    : '#000000'
}
